import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-14 my-10 flex flex-col justify-start w-full" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "col-span-12 grid grid-cols-12 gap-5 items-center" }
const _hoisted_5 = { class: "col-span-12 md:col-span-6 flex flex-col" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "col-span-12 md:col-span-6 flex items-center gap-3 mt-5" }
const _hoisted_8 = { class: "text-gray-400 text-sm w-72" }
const _hoisted_9 = { class: "col-span-12 grid grid-cols-12 gap-3" }
const _hoisted_10 = { class: "col-span-12 md:col-span-6 flex flex-col" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "col-span-12 md:col-span-6 flex flex-col" }
const _hoisted_13 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitPassword()), ["prevent"])),
      class: "grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Alterar senha",
                en: "Change password",
              })), 1),
          _createVNode(_component_Button, {
            type: "submit",
            label: "Salvar",
            class: "btn-primary p-button-sm",
            loading: _ctx.loading
          }, null, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Senha atual",
                en: "Actual password",
              })), 1),
          _createVNode(_component_InputPassword, {
            id: "password-input",
            modelValue: _ctx.form.currentPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.currentPassword) = $event)),
            feedback: false,
            toggleMask: "",
            class: _normalizeClass(_ctx.v$.form.currentPassword.$error ? 'p-invalid' : '')
          }, null, 8, ["modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.v$.form.currentPassword.$errors
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_icon, {
            name: "hi-information-circle",
            scale: 2,
            class: "text-gray-400"
          }),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Por questões de segurança, é necessário inserir a sua senha atual",
                en: "For security reasons, you must enter your current password",
              })), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Nova senha",
                en: "New password",
              })), 1),
          _createVNode(_component_InputPassword, {
            id: "password-input",
            modelValue: _ctx.form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
            feedback: false,
            toggleMask: "",
            class: _normalizeClass(_ctx.v$.form.password.$error ? 'p-invalid' : '')
          }, null, 8, ["modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.v$.form.password.$errors
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Confirmar nova senha",
                en: "Confirm new password",
              })), 1),
          _createVNode(_component_InputPassword, {
            id: "password-input",
            modelValue: _ctx.form.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
            feedback: false,
            toggleMask: "",
            class: _normalizeClass(_ctx.v$.form.confirmPassword.$error ? 'p-invalid' : '')
          }, null, 8, ["modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.v$.form.confirmPassword.$errors
          }, null, 8, ["errors"])
        ])
      ])
    ], 32)
  ]))
}